// Helper function to sanitize header values to ensure they only contain valid HTTP header characters
// HTTP headers must only contain ISO-8859-1 characters (0x00-0xFF), but control characters (0x00-0x1F except HTAB) are problematic
// This function removes or replaces invalid characters
export function sanitizeHeaderValue(value) {
  if (!value || typeof value !== 'string') return value;
  // Replace any character outside ISO-8859-1 range (0x00-0xFF) with a safe replacement
  // Also remove control characters except HTAB (0x09) and allow SP (0x20)
  return value
    .split('')
    .map(char => {
      const code = char.charCodeAt(0);
      // Allow: printable ASCII (0x20-0x7E), extended ASCII (0x80-0xFF), and HTAB (0x09)
      if ((code >= 0x20 && code <= 0x7E) || (code >= 0x80 && code <= 0xFF) || code === 0x09) {
        return char;
      }
      // Replace invalid characters with underscore
      return '_';
    })
    .join('');
}



